import { SidebarProvider } from "@/components/ui/sidebar";
import { DashboardSidebar } from "@/components/DashboardSidebar";
import { DashboardHeader } from "@/components/DashboardHeader";
import { DashboardFooter } from "@/components/DashboardFooter";
import { NotificationList } from "@/components/notifications/NotificationList";

const Notifications = () => {
  return (
    <div className="dark min-h-screen bg-[#1A1F2C]">
      <SidebarProvider>
        <div className="flex min-h-screen">
          <DashboardSidebar />
          <div className="flex-1 flex flex-col min-h-screen pl-64">
            <DashboardHeader />
            <main className="flex-1 px-6 py-8 mt-16">
              <div className="container mx-auto max-w-4xl">
                <h1 className="text-3xl font-bold text-white mb-8">Notifications</h1>
                <NotificationList />
              </div>
            </main>
            <DashboardFooter />
          </div>
        </div>
      </SidebarProvider>
    </div>
  );
};

export default Notifications;